export enum VerifyingDataStateEnum {
  NEW = 'NEW',
  UPDATE = 'UPDATE',
  VERIFIED = 'VERIFIED',
}
